var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.876 2.42688H22.2164V17.6894H13.876V2.42688Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4057 10.0585C14.4057 6.95746 15.8355 4.20691 18.0331 2.42713C16.418 1.13281 14.3793 0.35083 12.1552 0.35083C6.88591 0.35083 2.62305 4.69224 2.62305 10.0585C2.62305 15.4246 6.88591 19.7661 12.1551 19.7661C14.3792 19.7661 16.4179 18.9841 18.0331 17.6897C15.8355 15.9369 14.4057 13.1595 14.4057 10.0585Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4696 10.0585C33.4696 15.4246 29.2067 19.7661 23.9376 19.7661C21.7135 19.7661 19.6747 18.9841 18.0596 17.6897C20.2837 15.91 21.687 13.1595 21.687 10.0585C21.687 6.95746 20.2572 4.20691 18.0596 2.42713C19.6746 1.13281 21.7135 0.35083 23.9376 0.35083C29.2067 0.35083 33.4697 4.71926 33.4697 10.0585H33.4696Z",
    fill: "#E9EAF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLight);
export default __webpack_public_path__ + "static/media/mastercard-light.fc39e2cc3e303e4f025431042c8714c2.svg";
export { ForwardRef as ReactComponent };